import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: '14px 15px',
    background: theme.palette.grey.grey100,
    borderRadius: '16px',
    display: 'flex',
    fontFamily: 'Inter'
  },
  title: {

  },
  content: {
    fontSize: '14px',
    color: theme.palette.primary.primary900,
    fontFamily: 'Inter'
  },
  icon: {
    marginRight: '15px'
  }
}));

export default useStyles;
